module.exports = __webpack_public_path__ + "static/media/tray4.bb16b1d9.png";